export enum EnumPatientStatus {
  All = "All",
  Active = "Active",
  Expired = "Expired",
}
